import {HttpClient} from '@angular/common/http';
import {inject, Injectable} from '@angular/core';
import {Translation, TranslocoLoader, TranslocoService} from '@jsverse/transloco';
import {TRANSLOCO_PERSIST_LANG_STORAGE} from '@jsverse/transloco-persist-lang';
import {firstValueFrom} from 'rxjs';

@Injectable({providedIn: 'root'})
export class CustomTranslocoLoader implements TranslocoLoader {
  private http = inject(HttpClient);

  getTranslation(langPath: string) {
    return this.http.get<Translation>(`/assets/i18n/${langPath}.json`);
  }
}

/** Language INITIALIZER **/
export const preLoadLanguage = () => {
  const translocoService = inject(TranslocoService);
  const storage = inject(TRANSLOCO_PERSIST_LANG_STORAGE);

  const langFromStorage = storage.getItem('frontend-sample_lang');
  const parameters = new URLSearchParams(window.location.search);
  const lang = parameters.get('lang') || langFromStorage || 'en';
  translocoService.setActiveLang(lang);
  return firstValueFrom(translocoService.load(lang));
};
